import { FileMarkerIcon } from './FileMarkerIcon';

/**
 * author: Colton Wiscombe
 * id C6C876E6-1A2C-4776-9A4C-5114EF50D3DA
 * name file-marker
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-marker.svg
 * tags
 * - Files / Folders 
 * - Navigation 
 */
export const FileLocationIcon = FileMarkerIcon;
export default FileLocationIcon